import React, {
  createContext,
  Dispatch,
  memo,
  SetStateAction,
  useState,
  useContext,
} from "react";
import { ChildrenProps } from "Utils/types";
import { WebsocetLoader } from "Components/common/Loader";

// Keep the original context type for backward compatibility
// This context will continue to provide just the setter function
export type WebsocketLoaderContextType = Dispatch<
  SetStateAction<boolean>
> | null;

// Create a new context for the state value
export type WebsocketStateContextType = boolean;

// Original context for the setter (maintains backward compatibility)
export const WebsocketLoaderContext =
  createContext<WebsocketLoaderContextType>(null);

// New context for the state value
export const WebsocketStateContext =
  createContext<WebsocketStateContextType>(false);

// New hook to access both the value and the setter
export const useWebsocketLoader = () => {
  const setIsWSConnecting = useContext(WebsocketLoaderContext);
  const isWSConnecting = useContext(WebsocketStateContext);

  if (setIsWSConnecting === null) {
    throw new Error(
      "useWebsocketLoader must be used within a WebsocketLoaderProvider"
    );
  }

  return { isWSConnecting, setIsWSConnecting };
};

export const WebsocketLoaderController = memo(({ children }: ChildrenProps) => {
  const [isWSConnecting, setIsWSConnecting] = useState(false);
  return (
    <WebsocketLoaderContext.Provider value={setIsWSConnecting}>
      <WebsocketStateContext.Provider value={isWSConnecting}>
        {isWSConnecting && <WebsocetLoader />}
        {children}
      </WebsocketStateContext.Provider>
    </WebsocketLoaderContext.Provider>
  );
});
